<template>
  <el-container>
    <el-main style="padding: 0; width: 100vh">
      <view-table 
          ref="viewTable" 
          :filter="filter" 
          :limits="limits"
          :columns-property="columnsProperty"
          :table-select="false"
          module="basic" 
          url="codeRules"
          @addOrEdit="addEditHandle"
          @delete="deleteHandle"
          @reset="resetHandle">
        <template slot="adSearch">
          <div class="vm-search">
            <el-form :model="filter" :inline="true" @submit.native.prevent @keyup.enter.native="loadData(1)">
              <el-form-item label="规则名称：">
                <el-input v-model.trim="filter.tableName" placeholder="请输入规则名称" clearable/>
              </el-form-item>
            </el-form>
          </div>
        </template>
      </view-table>
    </el-main>
    <encoding-rules-edit ref="editPage" @save-success="loadData(1)"/>
  </el-container>
</template>
<script>
  import ViewTable from "@/components/ViewTable.vue";
  import EncodingRulesEdit from "./EncodingRulesEdit.vue";
  export default {
    name: "EncodingRulesList",
    components: { ViewTable, EncodingRulesEdit },
    data() {
      return {
        limits:{
          addAuth: this.$auth(281),
          editAuth: this.$auth(282),
          delAuth: this.$auth(283),
        },   
        filter: {
          tableName: "",
        },
        columnsProperty:[
          {
            title:"规则名称",
            key:"tableName",
            align:"center",
          },
          {
            title:"规则描述",
            key:"describe",
            align:"center",
          },
          {
            title:"编码前缀",
            key:"prefix",
            align:"center",
          },
          {
            title:"编码位数",
            key:"idlength",
            align:"center",
          },
          {
            title:"当前长度",
            key:"curID",
            align:"center",
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      addEditHandle(row) {
        this.$refs.editPage.open(row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      // 删除(单删、多删)
      deleteHandle(row) {
        this.$http.delete("basic", "codeRules", row.tableName).then((res) => {
          if (res.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>
<style scoped />
